import { REPORTS_IDS } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/constants.tsx';

export const connectPrefix = 'com.atlassian.plugins.atlassian-connect-plugin:';
export const jsdConnectPrefix = 'com.atlassian.servicedesk.connect';

const legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const jsdQueuesConnectSection = 'sd-queues-addons';
export const connectSections = [
	legacyAddonPanelLinkId,
	REPORTS_IDS.REPORTS_ADDONS,
	jsdQueuesConnectSection,
] as const;
